export const hasToken = ({ token }) => {
  return !!token
}
